module.exports = __webpack_public_path__ + "img/pro-m-slider8.60398f89.png";